export function formatNumber(number) {
  return parseFloat(number.replace(',', '.'));
}
